import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function ConnectionFailureDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("parentStation.connectionFailureDialog.heading")}
      text={t("parentStation.connectionFailureDialog.text")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
